export default __webpack_public_path__ + "static/media/icon-calendar.c6f8cb55.svg";